import { generateJob } from '../../data/apis/api';
import { useRestMutation } from '../../data/util';
import { useImportState } from './Import/useImportState';

export const useGenerateJobMutation = (transpilerId: string) => {
  const {
    actions: { updateTranspilationPreviewState }
  } = useImportState();
  const generateJobMutation = useRestMutation(
    (selectedFile: string) => {
      return generateJob(transpilerId, { selectedFile });
    },
    {
      retry: false,
      onSuccess: (resp) => {
        updateTranspilationPreviewState(resp.data, false, true);
      },
      sentryTag: 'transpiler.addJob'
    }
  );
  return generateJobMutation;
};
